module.exports = __webpack_public_path__ + "static/media/CUYA_RG_Website_v01.2bbd4bb1.mp4";